import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfButtonComponent } from '@ui/cf-button/cf-button.component';
import { CfProfileComponent } from '@ui/cf-profile/cf-profile.component';
import { CfStatusDisplayComponent } from '@ui/cf-status-display/cf-status-display.component';
import { CfUserProfileStackComponent } from '@ui/cf-user-profile-stack/cf-user-profile-stack.component';
import { CfTableColumnType, ICFTableColumnButtonOptions, ICFTableColumnTypeOptions } from './cf-table.component';

@Component({
    selector: 'app-cf-table-cell',
    template: `
<ng-container [ngSwitch]="columnType">
    <ng-container *ngSwitchCase="'status'"><app-cf-status-display [status]="column"></app-cf-status-display></ng-container>
    <ng-container *ngSwitchCase="'profile'"><app-cf-profile *ngIf="column" [urlOrInitials]="column" [width]="profileSizePx" [height]="profileSizePx"></app-cf-profile></ng-container> 
    <ng-container *ngSwitchCase="'profiles'"><app-cf-user-profile-stack *ngIf="column" [users]="column" [width]="profileSizePx" [height]="profileSizePx"></app-cf-user-profile-stack></ng-container>                     
    <ng-container *ngSwitchCase="'button'"><app-cf-button *ngIf="options?.button && column" [type]="options?.button?.type!" (click)="buttonClicked()">{{column}}</app-cf-button></ng-container>
    <ng-container *ngSwitchDefault>{{column}}</ng-container>
</ng-container>`,
    styles: [``],
    imports: [CommonModule, CfStatusDisplayComponent, CfProfileComponent, CfUserProfileStackComponent, CfButtonComponent]
})
export class CfTableCellComponent {
    @Input() columnType!: CfTableColumnType;
    @Input() column: any;
    @Input() options?: undefined | ICFTableColumnTypeOptions;
    @Input() profileSizePx = 50;

    @Output() click = new EventEmitter<string>();

    buttonClicked(): void {
        this.click.emit(this.column);
    }
}
